import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../styles/Header.css';
import { FaChevronDown } from 'react-icons/fa';
import AuthModal from './AuthModal';

function Header() {
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authType, setAuthType] = useState('login');
  const [showWriteDropdown, setShowWriteDropdown] = useState(false);
  const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const categories = [
    { id: 1, name: 'Aksiyon' },
    { id: 2, name: 'Bilim Kurgu' },
    { id: 3, name: 'Fantastik' },
    { id: 4, name: 'Genel Kurgu' },
    { id: 5, name: 'Genç Kurgu' },
    { id: 6, name: 'Gerilim' },
    { id: 7, name: 'Gizem' },
    { id: 8, name: 'Hayran Kurgu' },
    { id: 9, name: 'Klasikler' },
    { id: 10, name: 'Korku' },
    { id: 11, name: 'Kısa Hikaye' },
    { id: 12, name: 'Macera' },
    { id: 13, name: 'Mizah' },
    { id: 14, name: 'Paranormal' },
    { id: 15, name: 'Romantizm' },
    { id: 16, name: 'Spiritüel' },
    { id: 17, name: 'Tarihi Kurgu' },
    { id: 18, name: 'Texting' },
    { id: 19, name: 'Vampir' },
    { id: 20, name: 'Şiir' },
  ];

  const openAuthModal = (type) => {
    setAuthType(type);
    setShowAuthModal(true);
    setShowWriteDropdown(false);
    setShowCategoryDropdown(false);
  };

  const toggleWriteDropdown = () => {
    if (isLoggedIn) {
      setShowWriteDropdown(!showWriteDropdown);
    } else {
      openAuthModal('login');
    }
  };

  const toggleCategoryDropdown = () => {
    setShowCategoryDropdown(!showCategoryDropdown);
  };

  const navigateToCategory = (categoryId) => {
    if (isLoggedIn) {
      navigate(`/category/${categoryId}`);
      setShowCategoryDropdown(false);
    } else {
      openAuthModal('login');
    }
  };

  const handleAuthentication = () => {
    setIsLoggedIn(true);
    setShowAuthModal(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowWriteDropdown(false);
        setShowCategoryDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <header className="header">
      <div className="header-left">
        <div className="logo">
          <Link to="/">
            <img src="/LİBROZİ BOŞ MOR.png" alt="Logo" className="logo-image" />
          </Link>
        </div>
        <nav>
          <ul>
            <li>
              <button onClick={toggleCategoryDropdown}>
                Kategoriler <FaChevronDown />
              </button>
              {showCategoryDropdown && (
                <div className="category-dropdown" ref={dropdownRef}>
                  {categories.map((category) => (
                    <button 
                      key={category.id}
                      onClick={() => navigateToCategory(category.id)}
                    >
                      {category.name}
                    </button>
                  ))}
                </div>
              )}
            </li>
          </ul>
        </nav>
      </div>
      <div className="auth-buttons">
        <div className="write-dropdown" ref={dropdownRef}>
          <button onClick={toggleWriteDropdown} className="write-button">
            Yazmak <FaChevronDown />
          </button>
          {showWriteDropdown && (
            <div className="dropdown-menu">
              <button onClick={() => navigate('/create-story')}>Yeni bir hikaye oluştur</button>
              <button onClick={() => navigate('/my-stories')}>Hikayelerim</button>
            </div>
          )}
        </div>
        {isLoggedIn ? (
          <button onClick={() => setIsLoggedIn(false)}>Çıkış Yap</button>
        ) : (
          <>
            <button onClick={() => openAuthModal('login')}>Giriş yap</button>
            <button onClick={() => openAuthModal('signup')}>Kaydol</button>
          </>
        )}
      </div>
      {showAuthModal && (
        <AuthModal 
          type={authType} 
          onClose={() => setShowAuthModal(false)}
          onAuthenticated={handleAuthentication}
        />
      )}
    </header>
  );
}

export default Header;
